// extracted by mini-css-extract-plugin
export default {"container":"Payments_container__CsCXA","wrapper":"Payments_wrapper__20X7j","paragraph":"Payments_paragraph__DJp4t","icon":"Payments_icon__YN2fj"};